import styled from 'styled-components'

import FONTS from 'constants/fonts'

export const CheckboxWithDescription = styled.div`
  display: flex;
  justify-content: flex-start;
  max-width: 460px;
  margin: auto;
  span {
    text-align: left;
    font-size: ${FONTS.PARAGRAPHTINY};
  }
`
